import Page from '.';

export default Page;
